import footerlogo from "../assets/footlogo.png"

function Footer() {
    return (

<footer>
    <img src= {footerlogo}
         alt="Kasa logo of the footer"/>
    <p>© 2020 Kasa. All rights reserved</p>
</footer>
    );
}

export default Footer